import React from "react";
import {
  ArrowRight,
  Award,
  BookOpen,
  CreditCard,
  GraduationCap,
  Sparkles,
} from "lucide-react";
import "./TradePerformanceCentreNextStep.css";

const applicationSteps = [
  {
    id: "apply",
    step: "STEP 1",
    title: "Click Apply",
    text: "Start your application from any Apply Now button.",
    trend: "gold",
    icon: Sparkles,
  },
  {
    id: "program",
    step: "STEP 2",
    title: "Choose Your Program",
    text: "Select your programme, study mode, and cohort start date.",
    trend: "green",
    icon: GraduationCap,
  },
  {
    id: "spot",
    step: "STEP 3",
    title: "Secure Your Spot",
    text: "Choose a payment option and pay Module 1 before your start date.",
    trend: "red",
    icon: CreditCard,
  },
  {
    id: "learning",
    step: "STEP 4",
    title: "Start Learning",
    text: "Meet your lecturer, access your content, and join your first live lessons.",
    trend: "green",
    icon: BookOpen,
  },
  {
    id: "certified",
    step: "STEP 5",
    title: "Get Certified. Get Funded",
    text: "Complete your assessments and earn your funded account.",
    trend: "gold",
    icon: Award,
  },
];

const marketCandles = [
  "green",
  "green",
  "red",
  "green",
  "gold",
  "red",
  "green",
  "green",
  "red",
  "green",
];

function TradePerformanceCentreNextStep({
  applyHref = "https://andus.co.za/trade-register",
}) {
  return (
    <section className="trpc-nextStep" aria-labelledby="trpc-nextStep-title">
      <div className="trpc-nextStep-marketLayer" aria-hidden="true">
        <span className="trpc-nextStep-priceLine trpc-nextStep-priceLine--one" />
        <span className="trpc-nextStep-priceLine trpc-nextStep-priceLine--two" />

        <div className="trpc-nextStep-candleGroup">
          {marketCandles.map((trend, index) => (
            <span
              key={`${trend}-${index}`}
              className="trpc-nextStep-candle"
              data-trend={trend}
            />
          ))}
        </div>
      </div>

      <div className="trpc-nextStep-shell">
        <div className="trpc-nextStep-header">
          <div className="trpc-nextStep-terminalTop" aria-hidden="true">
            <span />
            <span />
            <span />
          </div>

          <span className="trpc-nextStep-kicker">How to Apply</span>

          <h2 id="trpc-nextStep-title" className="trpc-nextStep-title">
            Getting Started is Simple
          </h2>

          <p className="trpc-nextStep-lead">
            Apply, choose your programme, secure your place, and start learning
            live with real-world professionals.
          </p>

          <div className="trpc-nextStep-actions">
            <a
              className="trpc-nextStep-btn trpc-nextStep-btn--primary"
              href={applyHref}
              target="_blank"
              rel="noopener noreferrer"
              data-candle="green"
            >
              <span>Apply now</span>
              <ArrowRight size={17} strokeWidth={2.4} aria-hidden="true" />
            </a>
          </div>
        </div>

        <div className="trpc-nextStep-grid" aria-label="Application steps">
          {applicationSteps.map((item, index) => {
            const Icon = item.icon;

            return (
              <article
                key={item.id}
                className="trpc-nextStep-card"
                data-trend={item.trend}
                style={{ "--step-index": index }}
              >
                <div className="trpc-nextStep-cardTop">
                  <span className="trpc-nextStep-step">{item.step}</span>

                  <span className="trpc-nextStep-cardNumber" aria-hidden="true">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>

                <span className="trpc-nextStep-icon" aria-hidden="true">
                  <Icon size={25} strokeWidth={2.15} />
                </span>

                <div className="trpc-nextStep-cardCopy">
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default TradePerformanceCentreNextStep;